/* global angular */
angular
    .module('webcomm')
    .factory('wtcpjsService', [
        '$rootScope', 
        '$log', 
        '$q', 
        'wtcpjsClientProviderService',
        'muteService',
        'locationService',
        'channelModel', 
        'endpointModel',
        'feedModel',
        'profileModel',
        'privateCallService',
        'tupleDictionaryService',
        function($rootScope, $log, $q, wtcpjsClientProviderService, muteService, locationService, channelModel, endpointModel, feedModel, profileModel, privateCallService, tupleDictionaryService) {
            const INCOMING_AUDIO_SOUND_TIMEOUT_SECONDS = 5;
            const MAX_ACTIVE_CHANNELS = 16;
            var incomingAudioSoundPlayedAt;

            var channelsActivated = false;
            var deferredForChannelActivationFuncs = [];
            var service = {};
            var client = wtcpjsClientProviderService.getClient();
        
            var speakers = tupleDictionaryService;

            var myEndpointId; // isn't this always 1?
            var isSubscribed = false;
            var channelFilterId = wtcpjsClientProviderService.filterTypes.channelFilter;
            var privateTalkgroupSelfFilterId = wtcpjsClientProviderService.filterTypes.privateCallChannelSelfFilter;
            var privateTalkgroupFilterId = wtcpjsClientProviderService.filterTypes.privateCallChannelFilter;
            var addressBookFilterId = wtcpjsClientProviderService.filterTypes.addressBookFilter;
            var channelFilterActive = false;

            function activateChannels(channelIds) {
                channelsActivated = false;
                client.setEndpointPropertiesChannelActivityFilter("*")
                    .then(() => {
                        $log.info(`activating channels: ${channelIds}`);

                        //Need to add some code to test if any of the channelIds about to be activated are muted
                        //and only disable the audio if there is
                        client.AudioPlayerActive = false; // Disable all audio on client until we establish which channels (if any) are muted

                        client.setActiveChannels(channelIds)
                            .then(() => {
                                $rootScope.$applyAsync(function($scope) {
                                    $log.info(`channels activated: ${channelIds}`);
                                    channelsActivated = true;

                                    while(deferredForChannelActivationFuncs.length > 0) {
                                        deferredForChannelActivationFuncs.shift()();
                                    }

                                    channelModel.resetReadyState(channelIds);
                                    $rootScope.$broadcast('wtcpjsService.activeChannelsChanged', channelIds);
                                });
                            })
                            .catch((failedChannels) => {
                                // Do something in UI to reflect the failure to activate one or more channels
                                $log.error("One or more channels in your profile failed on activation", failedChannels);
                            });
                    });
            }

            function playIncomingAudioSound() {
                // if incomingAudioSoundPlayedAt === undefined then secondsPassed = timeout + 1
                let secondsPassed = incomingAudioSoundPlayedAt ? (new Date().getTime() - incomingAudioSoundPlayedAt.getTime()) / 1000 : INCOMING_AUDIO_SOUND_TIMEOUT_SECONDS + 1;
                if (secondsPassed > INCOMING_AUDIO_SOUND_TIMEOUT_SECONDS) {
                    new Audio('sounds/ptt_incoming_audio_received.mp3').play();
                }
                incomingAudioSoundPlayedAt = new Date();
            }

            function createEndpoint(channelId, endpointId, endpointName, endpointFlags) {
                let addSilently = channelId === 0 ? true : false;
                var newEndPoint = endpointModel.addEndpoint(
                    channelId,
                    endpointId,
                    endpointName,
                    endpointFlags,
                    addSilently);

                // This means we are just now acquiring the endpoint that represents the current user in the Wave system
                if (!myEndpointId) {
                    let shareLocationFunc = () => {
                        if (locationService.isSharingEnabled) {
                            locationService.shareLocation()
                                .catch((err) => {
                                    $log.warn(err);
                                });
                        }
                    }

                    if(channelsActivated) {
                        shareLocationFunc();
                    } else {
                        deferredForChannelActivationFuncs.push(shareLocationFunc);
                    }
                    myEndpointId = endpointModel.getMyEndpoint().id;
                }

                return newEndPoint;
            }

            function updateEndpointProperties(channelId, ep) {
                // Service endpoint, ex: media server recorder endpoint, file reader, etc...
                if (ep.properties.hasOwnProperty('state') && ep.properties.state === '0')
                    return;

                if (ep.properties.disposition === 'Gone') {
                    $rootScope.$broadcast("wtcpjsService.endpoint.gone", ep.endpointId);
                    return;
                }

                endpointModel.updateProperties(channelId, ep);
            }

            function clearChannelState(e, isReconnecting) {
                myEndpointId = void 0;
                speakers.init();
                if(!isReconnecting) {
                    channelModel.clearPrivateCallChannels();
                    channelModel.clearChannels();
                    endpointModel.clearEndpoints();
                }
            }

            // SPEAKING
            var startSpeaking = function(channelId, endpoint) {
                // only play sound if the channel isn't muted
                if (!muteService.getMuteStatus(channelId)) {
                    playIncomingAudioSound();
                }

                //console.log(`==> current speaker User Priority ${endpoint.UP} `);
                // pavel 5/20: the 'endpoint.name || endpoint.userName' is just so that the user sees _something_ until we get teh right
                // endpoint properties from the proxy
                speakers.put([channelId, endpoint.id], feedModel.addChannelFeedEvent(channelId, endpoint.name || endpoint.userName, "speaking", {
                    endpointId: endpoint.id,
                    UP: endpoint.UP,
                    self: endpoint.flags.get(channelId).Self || endpoint.userName === endpointModel.getMyEndpoint().userName,
                    startedSpeaking: new Date()
                }));
            };

            var stopSpeaking = function(channelId, endpoint) {
                feedModel.addChannelFeedEvent(channelId, endpoint.name, "end-speaking", { endpointId: endpoint.id, self: endpoint.flags.get(channelId).Self });
                if (typeof speakers.get([channelId,endpoint.id]) !== 'undefined') {
                    speakers.get([channelId,endpoint.id]).data.finishedSpeaking = new Date();
                    speakers.remove([channelId,endpoint.id]);
                }
            };

            var filterEndpoints = function(channelId) {

                if (channelId > 0) {
                    $log.info(`wtcpjsService applying new endpoint filter for channel ${channelId}`);

                    client
                        .setEndpointChannelFilter(channelFilterId, channelId, { 'displayName': '*' }, "*", 0, new WtcpJs.AnchorInfo())
                        .then((resp) => {

                            if (resp.subErrorCode === 121) {
                                endpointModel.setEndpointsDisabledOnChannel(channelId, wtcpjsClientProviderService.epFilterMaxNumChanEndpointsDisable);
                            } else {
                                if (resp.subErrorCode === 120) {
                                    endpointModel.setEndpointsTruncatedOnChannel(channelId);
                                }
                                endpointModel.clearEndpointsDisabledOnChannel(channelId);
                                endpointModel.clearEndpointsTruncatedOnChannel(channelId);
                                channelFilterActive = true;
                                $rootScope.$applyAsync(function ($scope) {
                                    // We are reloading a fresh set of endpoints, so clear out the old ones
                                    endpointModel.clearChannelEndpoints(channelId);

                                    //Get endpoint info from response now
                                    endpointModel.initializeEndpoints(channelId, resp);
                                });
                            }
                        })
                        .catch((err) => {
                            $log.error("TBD: REPLACE THIS ERROR: Failed to set Endpoint Channel Filter on Channel " + channelId + ", " + err.errorMessage, err);
                        });
                } else if (channelId < 0) {
                    $log.info('PrivateCall channel selected, wtcpjsService clearing channel filter');

                    endpointModel.clearChannelEndpoints(channelId);

                    if(channelFilterActive) {
                        channelFilterActive = false;
                        client.clearEndpointFilter(channelFilterId)
                            .catch((err) => {
                                $log.error("Unable to clear channel filter: " + err.errorMessage);
                            });
                    }
                }
            };

            service.getMaxActiveChannelCount = () => MAX_ACTIVE_CHANNELS;
            
            // activate channels and broadcast the channel list
            service.updateChannels = (updatedChannels) => {
                channelModel.clearChannels();

                for (let channel of updatedChannels) {
                    channelModel.addOrUpdateChannel(channel);

                    feedModel.addChannelFeedEvent(channel.channelId, '', "endpoint-joined", '');
                }

                if (channelModel.getSelectedChannel() && !updatedChannels.includes(channelModel.getSelectedChannel().id)) {
                    channelModel.clearSelectedChannel();
                }

                service.changeActiveChannels();
            };

            service.changeActiveChannels = () => {
                activateChannels(channelModel.getActiveChannelIds());
            };

            service.subscribeToEvents = () => {
                if (isSubscribed) {
                    return;
                }
                else {
                    isSubscribed = true;
                }
 
                client.onPTTOff.subscribe(function(x) {
                    $rootScope.$applyAsync(function($scope) {
                        $rootScope.$broadcast("wtcpjsService.pttOff");
                    });
                });

                client.onChannelActivity.subscribe(function(data) {
                    $rootScope.$applyAsync(function($scope) {
                        var channelId = data.channelId;
                        var channel = channelModel.getChannel(channelId);
                        channel.numEndpoints = data.numEndpoints;
                        $log.debug(`onChannelActivity (${channelId}), data`, data);

                        for (let proxyEP of data.endpoints) {

                            let epId = proxyEP.endpointInfo.endpointId;
                            let wcEndpoint = endpointModel.getChannelEndpoint(channelId, epId) ||
                                createEndpoint(channelId, epId, proxyEP.endpointInfo.endpointName, proxyEP.endpointInfo.endpointFlags);

                            // endpoint Gone
                            if (proxyEP.endpointInfo.endpointFlags.Gone) {
                                if(wcEndpoint.filterIds.includes(privateTalkgroupFilterId) ||
                                wcEndpoint.filterIds.includes(privateTalkgroupSelfFilterId)) {
                                    let selectedChannelId = channelModel.getSelectedChannel().id;
                                    endpointModel.deleteEndpoint(selectedChannelId, epId);
                                }
                                endpointModel.deleteEndpoint(channelId, epId);

                            } else {
                                endpointModel.updateFlags(channelId, epId, proxyEP.endpointInfo.endpointFlags);
                            }

                            if (Object.getOwnPropertyNames(proxyEP.endpointProperties).length > 0) {
                                // Massage the EndpointInfo into the same format as Unsolicited EP Prop Update
                                proxyEP.properties = proxyEP.endpointProperties;
                                proxyEP.endpointId = epId;
                                updateEndpointProperties(channelId, proxyEP);
                            }

                            // the speaking is for [channelId, wcEndpoint.id] of tupleDictionary
                            if (typeof speakers.get([channelId, wcEndpoint.id]) === 'undefined' && wcEndpoint.flags.get(channelId).Speaking) {
                                startSpeaking(channelId, wcEndpoint);
                                $rootScope.$broadcast("wtcpjsService.endpoint.speaking", { endpointId: wcEndpoint.id, started: true });
                            } else if (typeof speakers.get([channelId, wcEndpoint.id]) !== 'undefined' && !wcEndpoint.flags.get(channelId).Speaking) {
                                stopSpeaking(channelId, wcEndpoint);
                                $rootScope.$broadcast("wtcpjsService.endpoint.speaking", { endpointId: proxyEP.endpointId, started: false });
                            }
                        }

                        // select the the first channel if none are selected, ignoring the initial SPC related channel activity
                        if (channelId > 0) {
                            if (!channelModel.getSelectedChannel()) {
                                channelModel.selectChannel(channelId);
                            } else {
                                if (!channel.ready && channelModel.getSelectedChannel().id === channel.id) {
                                    filterEndpoints(channel.id);
                                }
                            }
                            channel.ready = true;
                        }
                    });
                });

                // TBD: Refactor this out of wtcpjsService. This really belongs in the endpointModel
                client.onEndpointPropertiesReceived.subscribe(function(ep) {
                        $rootScope.$applyAsync(function($scope) {
                            if (ep.filterIds.includes(channelFilterId) ||
                            ep.filterIds.includes(privateTalkgroupFilterId) ||
                            ep.filterIds.includes(privateTalkgroupSelfFilterId)) {
                                let selectedChannelId = channelModel.getSelectedChannel().id;

                                $log.debug(`onEndpointPropertiesReceived for channel ${selectedChannelId}`, ep);
                                let endpoint = endpointModel.getEndpoint(ep.endpointId); // We have this because of SPC channel activity

                                // Getting a bug here: TypeError: Cannot read property 'userName' of undefined
                                // Seems to happen when endpoint signs out
                                let wcEndpoint = endpointModel.getChannelEndpoint(selectedChannelId, ep.endpointId) ||
                                    createEndpoint(selectedChannelId, ep.endpointId, endpoint.userName, endpoint.flags.get(0));

                                if(wcEndpoint) {
                                    updateEndpointProperties(selectedChannelId, ep);
                                }

                            }

                            if (ep.filterIds.includes(addressBookFilterId)) {
                                $log.debug('onEndpointPropertiesReceived for AddressBook', ep);
                                updateEndpointProperties(0, ep);
                            }
                        });
                });

                client.onChannelPropertiesReceived.subscribe(function(event) {
                    $rootScope.$applyAsync(function($scope) {
                        var channel = channelModel.getChannel(event.channelId);
                        $log.debug(`onChannelPropertiesReceived (${event.channelId})`, event, channel);

                        let systemProps = event.properties.system;
                        channel.update(
                            systemProps.name,
                            systemProps.transmitAudio === "1",
                            systemProps.receiveAudio === "1",
                            systemProps.simplex === "1"
                        );

                        $rootScope.$broadcast("wtcpjsService.channelPropertiesReceived", channel);
                    });
                });

                client.onProxyUpdated.subscribe(function(event) {
                    $rootScope.$applyAsync(function($scope) {
                        console.warn('onProxyUpdated', event);
                        let channelId = event.channel;
                        let changeType = event.changeType;

                        switch (changeType) {
                        case 1:
                            channelModel.addEmptyChannel(channelId);
                            profileModel.addChannelToCurrentProfile(channelId);
                            service.changeActiveChannels();
                            break; // add channel - the following onChannelPropertiesReceived will take care of the rest
                        case 2:
                            channelModel.removeChannel(channelId);
                            profileModel.removeChannelFromCurrentProfile(channelId);
                            service.changeActiveChannels();
                            break;
                        //$rootScope.$broadcast('channelRemoved', event.channel);
                        case 3:
                            break; // channel updated - leave and return
                        case 4:
                            break; // channel updated - channel props coming
                        case 5:
                            profileModel.updateProfileName(event.profileName);
                            $rootScope.$broadcast('wtcpjsService.profileNameChanged', event.profileName); // profile name updated
                            break;
                        case 6:
                            break; // phone lines updated
                        default:
                        }
                    });
                });
            };

            $rootScope.$on('channelModel.channelSelected', (event, channel) => {
                filterEndpoints(channel.id);
            });

            $rootScope.$on('isReconnecting', (event, isReconnecting) => {
                if (isReconnecting) {
                    channelFilterActive = false;
                    myEndpointId = '';
                    endpointModel.clearEndpoints();
                }
            });

            $rootScope.$on('ConnectionService.logout', clearChannelState);

            $rootScope.$on('ConnectionService.connectionClosed', clearChannelState);

            $rootScope.$on('ConnectionService.credentialsValidated', (event, data) => {
                if (!data.reconnect) {
                    service.subscribeToEvents();
                }


                // Activate the first phone line. will need to add a phone line selection UI element to settings 
                // To allow user to control which phone line they want to use for private calling
                if(data.phoneLines.length > 0) {
                    privateCallService.activatePhoneLine(data.phoneLines[0]);
                }

                let channels = data.channels;

                if (channelModel.areChannelsNewOrChanged(channels)) {
                    service.updateChannels(channels);
                }
                else { //No changes since reconnect, just reactivate the channels we already know about
                      if (channelModel.reconnectedWithReducedActiveChannels(channels)) {
                         activateChannels(channelModel.getActiveChannelIds());
                      }
                      else {
                         activateChannels(channels.map(c => c.channelId));
                      }
                }
            });

            $log.debug('wtcpjsService initialized');
            return service;
        }
    ]);
